import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationInlineImproveShortFormAssetArgs,
  BackendShortFormAssetImprovement,
} from 'src/types/backend';

// The mutation also takes the continue half of the inline flow; a short-form asset only offers
// edits to a highlighted selection.
type Variables = Pick<
  BackendMutationInlineImproveShortFormAssetArgs,
  'variationId' | 'markedSegment' | 'recomposeMode' | 'instructions' | 'onlyImproveScore'
>;

const MUTATION = gql`
  mutation InlineImproveShortFormAsset(
    $variationId: ID!
    $markedSegment: MarkedSegment!
    $recomposeMode: RecomposeModeEnum
    $instructions: String
    $onlyImproveScore: Boolean
  ) {
    inlineImproveShortFormAsset(
      variationId: $variationId
      markedSegment: $markedSegment
      recomposeMode: $recomposeMode
      instructions: $instructions
      onlyImproveScore: $onlyImproveScore
    ) {
      segmentText
      assetText
      score
    }
  }
`;

export const inlineImproveShortFormAsset = async (
  variables: Variables
): Promise<BackendShortFormAssetImprovement | undefined> => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: { traceAcRequests: true },
  });
  return getSingleProp<BackendShortFormAssetImprovement>(response.data);
};
